// Generated types for VersioningOrigin
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from './neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from './neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningOriginReadAPI extends NeoNodeReadAPI {
  /** The island the changeset's ops are in. */
  island_id: string;
  /** The changeset (the ops' changeset_id). */
  changeset_id: string;
  /** pydantic-ai's tool call id (the chat's ToolCallPart). */
  tool_call_id: string;
  /** The agent's task. */
  task_id?: string | null;
  /** The task's chat (Thread). */
  chat_id?: string | null;
  /** The user message (Step) the turn answers. */
  turn_step_id?: string | null;
}

export interface VersioningOriginWriteAPI extends NeoNodeWriteAPI {
  /** The island the changeset's ops are in. */
  island_id: string;
  /** The changeset (the ops' changeset_id). */
  changeset_id: string;
  /** pydantic-ai's tool call id (the chat's ToolCallPart). */
  tool_call_id: string;
  /** The agent's task. */
  task_id?: string | null;
  /** The task's chat (Thread). */
  chat_id?: string | null;
  /** The user message (Step) the turn answers. */
  turn_step_id?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningOriginReadAPISchema: z.ZodType<VersioningOriginReadAPI> = NeoNodeReadAPISchemaObject.extend({
  island_id: z.string(),
  changeset_id: z.string(),
  tool_call_id: z.string(),
  task_id: z.string().nullable().optional(),
  chat_id: z.string().nullable().optional(),
  turn_step_id: z.string().nullable().optional(),
}).passthrough();

export const VersioningOriginWriteAPISchema: z.ZodType<VersioningOriginWriteAPI> = NeoNodeWriteAPISchemaObject.extend({
  island_id: z.string(),
  changeset_id: z.string(),
  tool_call_id: z.string(),
  task_id: z.string().nullable().optional(),
  chat_id: z.string().nullable().optional(),
  turn_step_id: z.string().nullable().optional(),
}).passthrough();
